<template lang="html">
    <div class="main-container">
         <breadcrumb
          :list="breadcrumbList"/>
        <toast-message :message="errmsg" type="error" :isToastEnable='toast' @close ="(val) => toast = val"/>

        <tl-header class="title margin-top-3" type="h3">Password Policy</tl-header><br>

        <span class="label"> Set Password Policy </span><br><br>
        <div class="policy-class">
            <span class="input-label"> Minimum Length </span>
            <txt class="custom-width" name="minimumLength" type="number" v-model="formData.minimumLength"/>
        </div><br>
        <div class="policy-filters">
            <tl-checkbox
              name="uppercase"
              label="Atleast one Uppercase"
              @change="(val)=>uppercase(val)"
              :checked="formData.atleastOneUppercase"/>
        </div><br>
        <div class="policy-filters">
            <tl-checkbox
            @change="(val)=>symbols(val)"
            :checked="formData.atleastOneSymbol"
            label="Atleast one Symbol"/>
        </div><br>
        <div class="policy-filters">
            <tl-checkbox
            @change="(val)=>numbers(val)"
            :checked="formData.numbers"
            label="Atleast one Number"/><br>
        </div><br><br>
        <div class="policy-filters">
                <tl-checkbox
                @change="(val)=>copyPolicy(val)"
                :checked="formData.copyPolicyVar"
                label="Copy this policy to all Legal Entities
                    (This will override the current password policy)."/>
        </div><br>

         <div class="modal" v-show="showSuccessMsg">
          <div class="modal-content">

            <p class="header header3 forgpass"><span class="text">Password Policy Set</span></p>
            <span class="label" v-show="formData.copyPolicyVar">New password policy implemented for all legal entities associated with your account.
                It will be effective from the next password change.</span><br>
            <span class="label" v-show="!formData.copyPolicyVar">New password policy successfully implemented.
                It will be effective from the next password change.
            </span><br>

            <div class="popup-btns">
                <btn text="Ok" type="primary" @click="ok"/>
            </div>
          </div>
        </div>

        <bottom-action-container>
            <template slot="end">
                <btn-grp>
                    <btn text="Back" type="secondary" @click="routeToSubStep" />
                    <btn text="Set Password Policy" type="primary" @click="save" />
                </btn-grp>
            </template>
        </bottom-action-container>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "resetPassword",
  computed: {
    ...mapState({}),
    ...mapGetters({
      orgid: "onboard/organization/orgid"
    })
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/employees`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        },
        {
          name: "Password Policy",
          url: ""
        }
      ],
      formData: {
        le_id: "",
        minimumLength: 0,
        atleastOneUppercase: false,
        atleastOneSymbol: false,
        atleastOneNumber: false,
        copyPolicyVar: false
      },
      legalEntitiesCount: 4
    };
  },
  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    }
  },
  mounted() {
    this.refresh();
    this.fetchPasswordPolicy();
  },

  activated() {
    this.refresh();
    this.fetchPasswordPolicy();
  },

  methods: {
    ...mapActions({
      act_fetch: "dashboard/organisation/utilities/passwordPolicy/fetchPolicy",
      act_create: "dashboard/organisation/utilities/passwordPolicy/create",
      act_update: "dashboard/organisation/utilities/passwordPolicy/update"
    }),

    refresh(){
      this.errmsg = "";
      this.toast = false;
    },

    async fetchPasswordPolicy() {
      try {
        this.formData.le_id = this.leId;

        let res = await this.act_fetch(this.leId);
        if (res.status) {
          let password_policy = res.data.payload.password_policy;

          if (password_policy) {
            this.formData.atleastOneNumber = password_policy.atleastOneNumber;
            this.formData.atleastOneSymbol = password_policy.atleastOneSymbol;
            this.formData.atleastOneUppercase =
              password_policy.atleastOneUppercase;
            this.formData.minimumLength = password_policy.minimumLength;
          }
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    routeToSubStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    routeToMainStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation`
      });
    },
    ok() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    setPasswordPolicy() {
      this.showSuccessMsg = true;
    },
    closeCard() {
      this.formData.showSelectedEmployee = false;
    },
    uppercase(val) {
      this.formData.atleastOneUppercase = val;
    },
    symbols(val) {
      this.formData.atleastOneSymbol = val;
    },
    numbers(val) {
      this.formData.atleastOneNumber = val;
    },
    copyPolicy(val) {
      this.formData.copyPolicyVar = val;
    },
    async save() {
      try {
        this.formData.le_id = this.leId;
        let obj = {
          data: {
            le_id: this.leId,
            password_policy: {
              minimumLength: this.formData.minimumLength,
              atleastOneUppercase: this.formData.atleastOneUppercase,
              atleastOneSymbol: this.formData.atleastOneSymbol,
              atleastOneNumber: this.formData.atleastOneNumber
            }
          }
        };
        this.$root._data.isSaving = true;
        let res = await this.act_create(obj);
        setTimeout(() => {
          if (res.status) {
            this.setPasswordPolicy();
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        this.errmsg = error;
        this.toast = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.margin-top-3 {
  margin-top: 3%;
}

.header.header3 {
  padding-bottom: 0px;
}
.policy-class {
  display: flex;
  span {
    margin-right: 10px;
    margin-top: 10px;
  }
}
.policy-filters {
  display: flex;
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
}

/* Modal Content */
.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 220px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 36px;

  .success-icon {
    margin-bottom: 40px;
  }
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
  .success-text {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: auto;
  }

  .popup-btns {
    margin-top: 2%;
    display: flex;
    justify-content: center;
  }
}
.custom-width {
  width: 5%;
}

.forgpass {
  padding: 0px;
  .text {
    font-size: 20px;
  }
}
</style>
